import { GenIcon } from '../helpers/IconBase.es.js';

const ClockAlternativeOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.4924 14.25C16.9066 14.2541 17.2458 13.9218 17.25 13.5076C17.2541 13.0934 16.9218 12.7542 16.5076 12.75L13.9874 12.7246C13.302 12.7177 12.75 12.1601 12.75 11.4746V8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V11.4746C11.25 12.9826 12.4644 14.2093 13.9722 14.2245L16.4924 14.25Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { ClockAlternativeOutlined };
